var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _rect, _rect2, _path37, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarCharging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 135,
    viewBox: "0 0 425 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M397.246 84.9058C389.006 77.6492 384.862 84.6368 395.022 88.7983C397.197 89.6892 399.574 90.5111 402.164 91.2227C403.701 91.6462 401.408 88.572 397.246 84.9058Z",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M375.055 73.9711C375.055 73.9711 375.062 73.971 375.061 73.971C374.907 73.9525 356.663 71.7707 346.061 70.684C337.183 69.7691 330.357 68.5863 328.328 68.2138C327.901 68.1354 327.475 68.0962 327.042 68.0962H321.198C319.985 68.0962 318.786 67.8479 317.695 67.3774L315.803 66.554C315.506 66.4233 315.16 66.4233 314.864 66.554V66.554C314.461 66.7238 314.025 66.717 313.635 66.518C309.119 64.2077 279.848 49.3524 262.863 43.6164C244.423 37.3886 227.022 39.2707 214.381 39.898C201.74 40.5254 162.258 46.7924 123.816 59.4832C95.4144 68.8543 85.5402 72.6314 82.3187 73.9646V73.9646C80.5827 74.6818 79.5146 76.4657 78.1017 77.7034C75.9122 79.6215 72.6684 82.6055 71.3466 84.5446C69.2663 87.5964 69.7864 94.0202 70.3931 98.8038C70.9999 103.581 71.2382 103.836 70.5881 105.012C69.938 106.188 70.0681 106.306 71.5633 108.652C73.0585 111.005 75.7816 115.762 78.9671 116.35C80.0248 116.546 84.1254 117.164 89.1265 117.902C99.7126 119.464 109.86 107.6 114.904 98.1628C116.778 94.6566 119.566 91.0775 123.643 87.6814C141.694 72.6445 166.238 84.2767 171.952 95.0854C177.041 104.714 177.185 109.68 176.328 120.618C176.139 123.03 178.114 125.407 180.129 124.068V124.068C181.534 123.137 266.388 123.924 301.773 124.294C309.988 124.38 316.219 117.234 317.139 109.07V109.07C317.919 102.137 323.633 83.5709 347.527 81.5778C371.421 79.5781 382.336 98.2614 381.426 109.776V109.776C380.912 116.269 387.06 124.212 393.571 124.023C402.383 123.767 413.091 123.328 419.734 122.609C422.465 122.313 423.779 119.498 422.529 117.052L422.414 116.826C422.273 116.55 422.178 116.252 422.133 115.945L422.09 115.654C421.995 115.014 421.625 114.446 421.076 114.103V114.103C420.124 113.506 419.761 112.289 420.142 111.232C421.157 108.421 422.7 102.819 421.226 97.7256C419.553 91.9601 403.27 85.6958 396.959 83.4643C395.32 82.8845 393.794 82.0495 392.374 81.0464C388.822 78.5383 381.402 73.9139 375.055 73.9711V73.9711Z",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M262.48 43.4983C260.862 44.0669 259.779 44.6093 259.064 45.0602C258.327 45.5242 258.378 46.524 259.143 46.9422C261.231 48.0793 265.832 50.5626 274.11 54.9475C282.181 59.225 290.597 64.5774 295.321 67.6766C297.812 69.3115 300.737 70.1779 303.714 70.0231C314.979 69.4369 327.526 68.1219 327.526 68.1219",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M285.263 70.4039V70.4039C287.542 70.3883 288.344 67.6969 286.454 66.4218C281.516 63.0897 273.766 58.144 265.579 54.0208C251.812 47.0873 246.402 44.9177 229.868 44.6824C213.334 44.4472 195.232 46.8782 178.178 51.0279C161.124 55.1775 150.817 58.2359 148.657 61.915C146.49 65.5942 170.478 66.6921 185.625 67.3194C196.243 67.7573 237.539 69.5086 265.94 70.1621",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.643 46.9815L205.96 68.1481",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M203.763 68.0565C203.763 68.0565 199.74 71.3501 199.284 74.1666C198.829 76.9832 199.87 85.2106 205.063 93.5557C210.257 101.901 213.767 110.122 225.454 112.474C237.141 114.827 303.797 115.526 316.77 115.644",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M296.292 70.4088C296.292 70.4088 301.811 72.6437 304.801 76.2837C307.791 79.9236 307.531 87.3865 307.336 92.7321C307.141 98.0776 304.736 115.506 304.736 115.506",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M176.711 113.684C176.711 113.684 282.192 116.978 316.769 116.978",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M203.272 114.481C203.272 114.481 194.452 100.842 190.472 94.5755C186.492 88.3085 179.804 88.6614 163.32 86.446",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.401 79.6828L105.166 80.382C103.707 81.2119 102.031 81.689 100.312 81.7674L77.5081 82.7803C76.9447 82.8065 76.5402 82.3033 76.7352 81.8328V81.8328C78.371 77.8452 82.8631 76.2257 87.1316 76.8225C101.048 78.7681 131.281 82.9734 131.603 82.8326",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M222.425 81.6534C222.422 81.6513 222.421 81.6484 222.42 81.6453C221.93 79.264 216.704 78.5982 211.254 78.3631C205.8 78.1278 202.571 78.4415 203.279 80.7156C203.98 82.9898 205.627 85.179 209.788 85.2574C213.939 85.3358 223.025 84.6309 222.429 81.6616C222.429 81.6585 222.427 81.6555 222.425 81.6534V81.6534Z",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M217.993 79.8333C217.993 79.8333 218.116 80.7874 214.641 80.7874H208.403C208.222 80.7874 208.1 80.9442 208.15 81.1011L208.677 82.6237C208.714 82.7217 208.815 82.7936 208.93 82.7936L220.564 82.9113",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M284.053 72.631C284.055 72.631 284.057 72.6298 284.058 72.6278L285.927 69.1675C286.31 68.4552 285.754 67.6253 284.873 67.6122L274.363 67.4227C274.023 67.4227 273.705 67.5599 273.496 67.8017L272.008 69.5792C271.459 70.2327 271.979 71.1737 272.882 71.1737H274.059C274.348 71.1737 274.637 71.1084 274.89 70.9777C275.266 70.7882 275.728 70.8143 276.075 71.043L276.241 71.1541C276.595 71.3829 276.804 71.7554 276.804 72.1474V72.1474C276.804 72.9237 277.139 73.6792 277.846 74.0001C279.046 74.5452 281.169 74.9877 283.601 73.1538C283.788 73.0108 283.939 72.829 284.047 72.6342C284.048 72.6322 284.05 72.631 284.053 72.631V72.631Z",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M284.54 67.6054C284.475 67.4682 283.103 64.6386 278.848 63.0245C274.594 61.4103 271.35 60.4366 269.306 61.8482C267.262 63.2597 265.976 64.5732 265.391 66.207C264.712 68.1086 265.391 70.3174 266.915 70.8206C268.439 71.3173 273.279 71.1735 273.279 71.1735",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M392.565 87.7272L392.341 87.9037C391.792 88.3284 391.098 88.5572 390.376 88.5506L371.451 88.4199",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M386.034 88.5574L383.167 90.3545C381.614 91.3282 379.765 91.851 377.872 91.851H374.903",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M420.258 102.255L419.68 100.36C419.435 99.5623 418.741 98.935 417.86 98.7193C415.671 98.1834 411.576 97.2489 410.131 97.3731C408.708 97.4973 405.566 100.693 403.84 102.562C403.348 103.091 403.767 103.895 404.526 103.895H411.749",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M421.84 102.254H420.329C415.615 102.254 411.851 106.181 412.05 110.891V110.891C412.066 111.28 412.049 111.67 412.077 112.058C412.146 113.016 412.582 114.841 414.87 115.056C417.983 115.35 422.043 115.311 422.043 115.311",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M417.138 102.255C417.138 102.255 418.048 102.196 417.528 104.254C417.146 105.766 415.642 109.968 414.87 112.092C414.564 112.936 413.964 113.807 414.246 114.66C414.282 114.77 414.335 114.881 414.408 114.991",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M380.631 116.814C380.631 116.814 411.25 118.272 422.208 116.409",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M316.943 123.414L310.125 122.225L205.287 117.611C203.914 117.552 202.535 117.67 201.198 117.97C196.706 118.977 186.347 121.506 184.932 123.773",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M196.951 118.983L198.345 119.781C201.249 121.454 204.615 122.362 208.061 122.414L316.987 124.022",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M144.62 134.21C160.377 134.21 173.151 122.653 173.151 108.397C173.151 94.1405 160.377 82.5836 144.62 82.5836C128.862 82.5836 116.088 94.1405 116.088 108.397C116.088 122.653 128.862 134.21 144.62 134.21Z",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M158.445 120.9C166.078 113.994 166.078 102.797 158.445 95.8915C150.812 88.9856 138.436 88.9856 130.803 95.8915C123.169 102.797 123.169 113.994 130.803 120.9C138.436 127.806 150.812 127.806 158.445 120.9Z",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M349.818 134.21C365.576 134.21 378.35 122.653 378.35 108.397C378.35 94.1405 365.576 82.5836 349.818 82.5836C334.06 82.5836 321.286 94.1405 321.286 108.397C321.286 122.653 334.06 134.21 349.818 134.21Z",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M354.358 125.602C364.857 123.332 371.334 113.792 368.825 104.293C366.316 94.7938 355.771 88.9336 345.272 91.2035C334.772 93.4735 328.295 103.014 330.804 112.513C333.313 122.012 343.858 127.872 354.358 125.602Z",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M378.696 124.342H376.587C376.197 124.342 375.886 124.055 375.886 123.708C375.886 123.199 375.388 122.806 374.824 122.878L373.293 123.081",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M326.29 123.01L316.979 123.128",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M180.129 124.068L179.428 125.382C179.053 126.087 178.338 126.591 177.493 126.754L176.532 126.937C175.911 127.055 175.333 126.63 175.333 126.055V126.055C175.333 124.658 174.201 123.526 172.804 123.526H171.593C170.98 123.526 170.379 123.681 169.815 123.922C169.016 124.264 167.793 124.697 166.795 124.669",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M121.78 123.865C121.78 123.865 90.7129 122.166 84.0892 121.224C77.4655 120.283 72.337 117.996 70.1917 113.703C68.5175 110.357 68.6645 109.193 68.8098 108.843C68.844 108.76 68.8541 108.654 68.8048 108.579V108.579C68.5231 108.161 68.6531 107.612 69.101 107.338L70.3289 106.58",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7297 103.895C73.648 103.336 74.8969 101.874 75.4519 101.98C76.5541 102.192 77.8885 102.455 79.176 102.725C81.6319 103.241 83.835 104.967 84.4562 105.535C84.5212 105.594 84.4707 105.692 84.3768 105.685C83.1344 105.607 77.6519 105.241 74.4737 104.627C74.0764 104.548 73.7875 104.254 73.7297 103.895V103.895Z",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M315.708 75.7219C315.708 77.9111 319.486 80.3355 324.145 80.3355C328.804 80.3355 332.581 77.9045 332.581 75.7219C332.581 73.5392 328.804 71.7617 324.145 71.7617C319.486 71.7617 315.708 73.5327 315.708 75.7219Z",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1279 3.69388V129.641C28.1279 131.245 26.8278 132.545 25.2241 132.545C23.6204 132.545 22.3203 131.245 22.3203 129.641V3.69388C22.3203 2.09016 23.6204 0.790088 25.2241 0.790088C26.8278 0.790088 28.1279 2.09016 28.1279 3.69388Z",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.15 51.6232L40.15 74.1971C40.15 83.1247 37.7672 113.898 63.744 113.898C89.7209 113.898 95.8952 111.906 104.511 100.51C113.127 89.1139 118.813 68.9416 138.052 68.9416",
    stroke: "#28885A",
    strokeWidth: 3.49854,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M40.15 50.9242L40.15 74.1971C40.15 83.1247 37.7672 113.898 63.744 113.898C89.7209 113.898 95.8952 111.906 104.511 100.51C113.127 89.1139 118.813 68.9416 138.052 68.9416",
    stroke: "#3CC985",
    strokeWidth: 1.74927,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeDasharray: "3.5 7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M142.738 72.5253C144.67 72.5253 146.236 70.959 146.236 69.0268C146.236 67.0946 144.67 65.5282 142.738 65.5282C140.806 65.5282 139.239 67.0946 139.239 69.0268C139.239 70.959 140.806 72.5253 142.738 72.5253Z",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.734375,
    y: 131.064,
    width: 48.9796,
    height: 2.93878,
    rx: 1.46939,
    fill: "#3CC985"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8477,
    y: 42.1778,
    width: 6.99708,
    height: 2.93878,
    rx: 1.46939,
    fill: "#3CC985"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6208 15.0641V44.8018C45.6208 47.8546 43.146 50.3294 40.0932 50.3294C37.0403 50.3294 34.5655 47.8546 34.5655 44.8017V15.0641C34.5655 12.0113 37.0403 9.53644 40.0932 9.53644C43.146 9.53644 45.6208 12.0113 45.6208 15.0641Z",
    stroke: "#3CC985",
    strokeWidth: 1.1895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8477,
    y: 15.9388,
    width: 6.99708,
    height: 2.93878,
    rx: 1.46939,
    fill: "#3CC985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarCharging);
export default __webpack_public_path__ + "static/media/car-charging.4d97f21c365df629f9c8a6dd3cbd12d0.svg";
export { ForwardRef as ReactComponent };